import {
  Avatar,
  Badge,
  Button,
  SystemIcon,
} from "@justworkshr/milo-components";
import styles from "./Prefilled.module.css";
import { getMemberUuid } from "utils/idHelpers";
import { SingleCensusType, SingleDependentType } from "types";
import { HealthCensusType } from "./types";

interface PrefilledCensusProps {
  census: {
    censusData: SingleCensusType | HealthCensusType;
    complete: boolean;
  };
  onClick: (census: SingleCensusType | HealthCensusType) => void;
  updateDependent?: (
    dependentData: SingleDependentType | null,
    employeeData: SingleCensusType,
    isDelete?: boolean
  ) => void;
  flowName: string;
}

const PrefilledCensus = ({
  census,
  onClick,
  updateDependent,
  flowName,
}: PrefilledCensusProps) => {
  const { censusData } = census;
  const isFirstUser = censusData.uuid === getMemberUuid();

  const handleDependentClick = (
    dependentData: SingleDependentType | null,
    employeeData: SingleCensusType,
    isDelete?: boolean
  ) => {
    if (updateDependent) {
      updateDependent(dependentData, employeeData, Boolean(isDelete));
    }
  };

  return (
    <li key={censusData.uuid}>
      <div className={styles.prefilledEmployee}>
        <div className={`${styles.employeeTableColumn} ${styles.employeeName}`}>
          <Avatar
            name={`${censusData.firstName} ${censusData.lastName}`}
            size="xs"
          />
          <div>
            <span>
              {censusData.firstName} {censusData.lastName}
            </span>
            {isFirstUser && (
              <Badge
                className={styles.firstUserBadge}
                emphasis="subtle"
                role="neutral"
              >
                You
              </Badge>
            )}
          </div>
        </div>
        <div className={styles.employeeTableColumn}>
          {censusData.isCompanyOwner ? "Owner" : "Employee"}
          {censusData.isCompanyOwner &&
            (censusData.employeeInformation?.isPaid === "Paid"
              ? " | Paid"
              : " | Unpaid")}
        </div>
        <div>
          {!census.complete && <Badge role="warning">Action Required</Badge>}
          {census.complete &&
            flowName === "wc" &&
            // @ts-ignore
            censusData.employeeInformation?.title}
          {census.complete && flowName === "hi" && (
            <>
              {
                // @ts-ignore
                censusData.healthInsInfo?.isWaiving && (
                  <Badge color="destructive">Waived coverage</Badge>
                )
              }
            </>
          )}
        </div>
        <div className={styles.employeeTableButtonContainer}>
          {census.complete ? (
            <>
              {
                // @ts-ignore
                flowName === "hi" && !censusData.healthInsInfo?.isWaiving && (
                  <Button
                    className={styles.employeeTableButton}
                    variant="ghost"
                    size="sm"
                    onClick={() => handleDependentClick(null, censusData)}
                  >
                    Add dependent
                  </Button>
                )
              }
              <SystemIcon
                iconName="edit"
                color="brand"
                title="Edit"
                size="small"
                className={styles.employeeTableButton}
                onClick={() => onClick(censusData)}
              />
            </>
          ) : (
            <Button
              className={styles.employeeTableButton}
              variant="ghost"
              size="sm"
              onClick={() => onClick(censusData)}
            >
              Update
            </Button>
          )}
        </div>
      </div>
      {flowName === "hi" && // @ts-ignore
        censusData.dependents &&
        // @ts-ignore
        censusData.dependents?.length > 0 && (
          <ul className={styles.dependentList}>
            {
              // @ts-ignore
              censusData.dependents &&
                // @ts-ignore
                censusData.dependents.map((dep, idx) => (
                  <li
                    key={dep.dependentData?.uuid}
                    className={styles.dependentItem}
                  >
                    <div />
                    <div className={styles.dependentType}>
                      {dep.dependentData?.participantType || ""}
                    </div>
                    <div>
                      {dep.complete ? (
                        `${dep.dependentData?.firstName} ${dep.dependentData?.lastName}`
                      ) : (
                        <Badge>Action Required</Badge>
                      )}
                    </div>
                    <div className={styles.employeeTableButtonContainer}>
                      <Button
                        className={styles.employeeTableButton}
                        variant="ghost"
                        color="destructive"
                        size="sm"
                        onClick={() =>
                          handleDependentClick(
                            dep.dependentData,
                            censusData,
                            true
                          )
                        }
                      >
                        Remove
                      </Button>
                      {dep.complete && (
                        <SystemIcon
                          iconName="edit"
                          color="brand"
                          title="Edit"
                          size="small"
                          className={styles.employeeTableButton}
                          onClick={() =>
                            handleDependentClick(dep.dependentData, censusData)
                          }
                        />
                      )}
                    </div>
                  </li>
                ))
            }
          </ul>
        )}
    </li>
  );
};

export default PrefilledCensus;
